import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "App-Terms-Page-Header" }
const _hoisted_2 = {
  primary: "",
  "f-w-700": ""
}
const _hoisted_3 = {
  target: "body",
  offset: 70
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_top_nav = _resolveComponent("app-top-nav")!
  const _component_TermsNavComponent = _resolveComponent("TermsNavComponent")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_el_collapse_transition = _resolveComponent("el-collapse-transition")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_app_main_footer = _resolveComponent("app-main-footer")!
  const _component_app_main_layout = _resolveComponent("app-main-layout")!

  return (_openBlock(), _createBlock(_component_app_main_layout, { putOnMax: false }, {
    "top-nav": _withCtx(() => [
      _createVNode(_component_app_top_nav)
    ]),
    main: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$route.meta.title), 1)
        ]),
        _createVNode(_component_el_container, { class: "App-Terms-Subpages-H" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_aside, { width: "200px" }, {
                default: _withCtx(() => [
                  _createVNode(_component_TermsNavComponent)
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_el_main, { class: "App-Terms-Sub-H-Main" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_view, null, {
                  default: _withCtx(({ Component }) => [
                    _createVNode(_component_el_collapse_transition, null, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_app_main_footer, { showBanner: false })
    ]),
    _: 1
  }))
}